import {
  NotEligibleStep,
  SignDocumentsStep,
  StudentEnrolledDetails
} from '../../../../components'
import { ENROLLMENT_PUBLIC_LINKS } from '../../../../constants/enrollmentContent'
import {
  SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS,
  SELF_ENROLLMENT_STEPS
} from '../../utils/steps'
import type { FlowStepRendererProps, SharedStepProps } from './types'

type OutcomeStepProps = Pick<
  FlowStepRendererProps,
  'currentStep' | 'enrollmentState' | 'docusignState' | 'navigation'
> & {
  stepProps: SharedStepProps
}

export function renderOutcomeStep({
  currentStep,
  enrollmentState,
  docusignState,
  navigation,
  stepProps
}: OutcomeStepProps) {
  switch (currentStep) {
    case SELF_ENROLLMENT_STEPS.SIGN_DOCUMENTS:
    case SELF_ENROLLMENT_STEPS.SIGNED_COMPLETE:
      return (
        <SignDocumentsStep
          {...stepProps}
          onNext={() => {
            void enrollmentState.handleFinalizeEnrollment()
          }}
          isSigned={docusignState.isSignatureSigned}
          isPreparingSignature={docusignState.isPreparingDocusign}
          isCheckingSignature={docusignState.isCheckingSignature}
          isFinalizingEnrollment={enrollmentState.isFinalizingEnrollment}
          signatureStatus={docusignState.signatureStatus}
          onOpenSigning={docusignState.onOpenSigning}
          errorMessage={enrollmentState.stepSubmissionError}
        />
      )
    case SELF_ENROLLMENT_STEPS.ENROLLMENT_COMPLETE:
      return <StudentEnrolledDetails {...stepProps} />
    case SELF_ENROLLMENT_STEPS.NOT_ELIGIBLE:
      return (
        <NotEligibleStep
          currentStep={SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS - 1}
          totalSteps={SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS}
          onBack={() => {
            navigation.setCurrentStep(SELF_ENROLLMENT_STEPS.ELIGIBILITY)
            navigation.scrollToTop()
          }}
          onLearnMore={() => {
            window.open(ENROLLMENT_PUBLIC_LINKS.cdlTraining, '_blank', 'noopener,noreferrer')
          }}
        />
      )
    default:
      return null
  }
}
